var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataRoomAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_2",
    clipPath: "url(#clip1_0_363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.5 16C5.5 17.3789 5.77159 18.7443 6.29926 20.0182C6.82694 21.2921 7.60036 22.4496 8.57538 23.4246C9.55039 24.3996 10.7079 25.1731 11.9818 25.7007C13.2557 26.2284 14.6211 26.5 16 26.5C17.3789 26.5 18.7443 26.2284 20.0182 25.7007C21.2921 25.1731 22.4496 24.3996 23.4246 23.4246C24.3996 22.4496 25.1731 21.2921 25.7007 20.0182C26.2284 18.7443 26.5 17.3789 26.5 16C26.5 13.2152 25.3938 10.5445 23.4246 8.57538C21.4555 6.60625 18.7848 5.5 16 5.5C13.2152 5.5 10.5445 6.60625 8.57538 8.57538C6.60625 10.5445 5.5 13.2152 5.5 16Z",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.19993 12.5H25.7999",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.19993 19.5H25.7999",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4167 5.5C13.4513 8.64955 12.4093 12.2875 12.4093 16C12.4093 19.7125 13.4513 23.3505 15.4167 26.5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.5833 5.5C18.5487 8.64955 19.5907 12.2875 19.5907 16C19.5907 19.7125 18.5487 23.3505 16.5833 26.5",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRoomAvatar);
export default __webpack_public_path__ + "static/media/data-room-avatar.b2f691530c100987dd91e900fd9a136d.svg";
export { ForwardRef as ReactComponent };